import { render, staticRenderFns } from "./ClockDetail.vue?vue&type=template&id=f686f672&scoped=true&"
import script from "./ClockDetail.vue?vue&type=script&lang=js&"
export * from "./ClockDetail.vue?vue&type=script&lang=js&"
import style0 from "./ClockDetail.vue?vue&type=style&index=0&id=f686f672&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f686f672",
  null
  
)

export default component.exports